import { Link } from "react-router-dom";

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  author: string;
  authorAvatar: string;
  category: string;
  categorySlug: string;
  image: string;
  publishDate: string;
  readTime: number;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  author,
  authorAvatar,
  category,
  categorySlug,
  image,
  publishDate,
  readTime,
  tags,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full aspect-[16/9] overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${categorySlug}`}
              className="inline-block px-3 py-1 bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800 rounded-full hover:bg-background-50 transition-colors"
            >
              {category}
            </Link>
          </div>
        </div>
      </Link>

      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <img
            src={authorAvatar}
            alt={author}
            className="w-7 h-7 rounded-full object-cover"
          />
          <span className="text-xs text-foreground-600">{author}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-500">{publishDate}</span>
        </div>

        <Link to={`/article/${slug}`} className="block group/link">
          <h3 className="text-base font-semibold text-foreground-900 leading-snug group-hover/link:text-primary-500 transition-colors line-clamp-2 mb-2">
            {title}
          </h3>
        </Link>

        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 flex-wrap">
            {tags.slice(0, 2).map((tag) => (
              <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded-md">
                {tag}
              </span>
            ))}
          </div>
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            {readTime} 分钟阅读
          </span>
        </div>
      </div>
    </article>
  );
}